<ccl-page-header>
    <div class="s-page-header__left c-page-header__left"><div class="c-title c-title--secondary">Filter</div></div>
    <div class="s-page-header__right">
        <ccl-toggle-button
            [title]="filterSetup.isFilterEnabled ? 'Enable' : 'Disable'"
            [isChecked]="filterSetup.isFilterEnabled"
            (isCheckedChange)="toggleFilterEnable($event)"
            >{{ filterSetup.isFilterEnabled ? "Enable" : "Disable" }}</ccl-toggle-button
        >
    </div>
</ccl-page-header>

<div class="row row--builder align-tabs">
    <div class="col col-sm-6 tab_pad" [ngClass]="{'tab_active': selectedTab === 'filter'}" (cclClick)="selectTab('filter')">Filter</div>
    <div class="col col-sm-6 tab_pad" [ngClass]="{'tab_active': selectedTab === 'saveFilter'}" (cclClick)="selectTab('saveFilter')">Save Filter</div>
</div>

<ccl-content-section *ngIf="filterSetup.isFilterEnabled && selectedTab === 'filter'">
    <div class="row" (cclClick)="openConfigDrawer('filter')" title="Edit Filter">
        <div class="offset-sm-3 col-sm-6 col-xs-12">
            <div class="col-12 plr0 filterPreviewMainBox">
                <div class="col-sm-12 filterSectionHeader" [ngStyle]="headerStyle">
                    <div class="row">
                        <h3 class="text-uppercase col-sm-6" [ngStyle]="headerStyle">{{ filterSetup.label }}</h3>
                        <h3 class="col-sm-6"><span class="pull-right" [ngStyle]="headerStyle">Clear All</span></h3>
                    </div>
                </div>
                <div class="col-sm-12 col-xs-12 plr0 filterPreviewBox" [ngStyle]="bodyStyle">
                    <div
                        [ngClass]="
                            i == filterSetup.selectedFields.length
                                ? 'text-uppercase ptb10'
                                : 'text-uppercase ptb10 filterItemRow'
                        "
                        *ngFor="let field of filterSetup.selectedFields; let i = index"
                    >
                        <span>{{
                            field.type == "standardFields"
                                ? labelJSON?.filter_section[field.field]
                                : customFieldLabels[field.field]
                        }}</span>
                        <span
                            ><i [title]="'Collapse'"
                                class="{{
                                    filterSetup.expansionStyles == 1
                                        ? 'fa fa-chevron-down removeIcon'
                                        : 'fa fa-chevron-circle-down removeIcon'
                                }}"
                            ></i
                        ></span>
                    </div>
                    <div [ngClass]="
                    filterSetup.showTimezoneFilter == true
                        ? 'text-uppercase ptb10 filterItemRow'
                        : 'text-uppercase ptb10'
                " *ngIf="filterSetup.showMysessionsFilter == true">
                    <span>{{ labelJSON?.filter_section['my_session'] }}</span>
                    <span
                        ><i [title]="'Collapse'"
                            class="{{
                                filterSetup.expansionStyles == 1
                                    ? 'fa fa-chevron-down removeIcon'
                                    : 'fa fa-chevron-circle-down removeIcon'
                            }}"
                        ></i
                    ></span>
                    </div>
                    <div class="text-uppercase ptb10" *ngIf="filterSetup.showTimezoneFilter == true">
                        <span>{{ labelJSON?.filter_section['time_zone'] }}</span>
                        </div>
                </div>
            </div>
        </div>
    </div>
</ccl-content-section>

<ccl-content-section *ngIf="filterSetup.isFilterEnabled && selectedTab === 'saveFilter'">
    <div>
        <ccl-basic-button
                (clickEvent)="openFilterDrawer('saveFilter')"
                buttonStyle="c-btn--secondary pull-right"
                >Create Filter
            </ccl-basic-button>
    </div>
    <br/>
    <br/>
    <div class="filter-list sessions-to-display-drawer--list">
        <ccl-list
            class="catalog-list"
            [list]="filters"
            [columns]="columns"
            [hideFilters]="true"
            [compact]="true"
            selectionProperty="false"
            (filterChangeEvent)="loadFilters($event)"
            [showPagination]="false"
        >
            <span *ngIf="noFilters">No Saved Filters.</span>
        </ccl-list>
    </div>

</ccl-content-section>
